import { connect, useSelector } from "react-redux";
import MembershipDurationForm from "./components/MembershipDurationForm";
import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { validatePackageForm } from "./components/FormValidation";
import { ApiError } from "components";
import { CreatePackageError } from "modules/membership_plan/commercial_membership_plan/packages/store/actionType";
import { updateMembershipDuration } from "../../store/action";
import {
  MembershipDurationsProps,
  CreateMembershipDurationInput,
  UpdateMembershipDurationInput,
} from "../../store/actionType";

type OwnProps = {
  membershipData: MembershipDurationsProps;
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
};
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & OwnProps & StateProps;
const HandleUpdateMembershipDuration: React.FC<Props> = ({
  closeModal,
  onUpdateMembershipDuration,
  membershipData,
}) => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState<CreateMembershipDurationInput>({
    duration_type: membershipData.duration_type,
    price: membershipData.price,
    number_of_days: membershipData.number_of_days,
    description: membershipData.description,
    package_id: membershipData.package_id,
    price_usd:membershipData.price_usd

  });
  const [error, setError] = useState<CreatePackageError>({});
  const [apiError, setApiError] = useState(null);
  const membershipState = useSelector(
    (state: any) => state.membershipDuration?.genericMembershipDurationState
  );
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value, type } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "number" ? Number(value) : value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    const input = {
      duration_type: formData.duration_type,
      price: formData.price,
      number_of_days: formData.number_of_days,
      description: formData.description,
      duration_id: membershipData.id.toString(),
      package_id: membershipData.package.id.toString(),
      price_usd:formData.price_usd
    };
    const { isValid, errors } = validatePackageForm(formData);
    setError(errors);

    if (!isValid) return;

    if (
      formData.description.trim() !== "" &&
      formData.duration_type.trim() !== "" &&
      formData.price !== "" &&
      formData.number_of_days !== ""
    ) {
      setSubmitted(true);
      setLoading(true);
      try {
        await onUpdateMembershipDuration(input);
      } catch (err) {
        console.error("Failed to create package:", err);
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    if (!membershipState.isLoading && submitted) {
      if (membershipState.status === "SUCCESS") {
        closeModal(false);
        setApiError(null);
        setSubmitted(false);
      }
      if (membershipState.status === "FAILED") {
        setApiError(membershipState.error);
      }
    }
  }, [membershipState.isLoading, membershipState.status, submitted]);
  return (
    <>
      <MembershipDurationForm
        handleSave={handleSave}
        formData={formData}
        handleChange={handleChange}
        error={error}
        loading={loading}
        header={"Update Membership Duration"}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    fetchMembershipDurationByPackageId:
      state.membershipDuration?.fetchmembershipDurationState,
  };
};
const mapDispatchToProps = (dispatch: any) => ({
  onUpdateMembershipDuration: (input: UpdateMembershipDurationInput) =>
    dispatch(updateMembershipDuration(input)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HandleUpdateMembershipDuration);
